export enum VariantEnum {
  DEFAULT = 'default',
  OUTLINED = 'outlined',
}

export type Variant = VariantEnum.DEFAULT | VariantEnum.OUTLINED;
